import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    redirectOnMount: Boolean,
    redirectUrl: String
  };

  connect() {
    if (!this.redirectOnMountValue) {
      return;
    }

    if (window === window.top) {
      window.location.href = this.redirectUrlValue;
      return;
    }

    this.sendRedirectMessage();
  }

  sendRedirectMessage() {
    window.top.postMessage(
      { type: "iframeRedirect", redirectUrl: this.redirectUrlValue },
      "*"
    );
  }
}
